export const BRAZIL = 'BRAZIL';
export const HSFS_SEED_V2 = 'HSFS_SEED_V2';
export const HSFS_SERIES_A_V2 = 'HSFS_SERIES_A_V2';
export const HSFX_ENTREPRENEUR_V2 = 'HSFX_ENTREPRENEUR_V2';
export const STRATEGIC_PARTNERSHIP = 'STRATEGIC_PARTNERSHIP';
export const HSFX_BOOTSTRAP = 'HSFX_BOOTSTRAP';
export const LATAM_ES = 'LATAM_ES';
export const MARKETING_BASIC_TO_PRO = 'MARKETING_BASIC_TO_PRO';
export const NO_PROMOTION = 'NO_PROMOTION';
export const WINTER_NEW_CUSTOMER_STARTER_2024_PROMOTION = 'WINTER_NEW_CUSTOMER_STARTER_2024_PROMOTION';
export const HSFS_SEED_V3 = 'HSFS_SEED_V3';
export const promotionKeys = {
  BRAZIL,
  HSFS_SEED_V2,
  HSFS_SEED_V3,
  HSFS_SERIES_A_V2,
  HSFX_ENTREPRENEUR_V2,
  STRATEGIC_PARTNERSHIP,
  HSFX_BOOTSTRAP,
  LATAM_ES,
  MARKETING_BASIC_TO_PRO,
  NO_PROMOTION,
  WINTER_NEW_CUSTOMER_STARTER_2024_PROMOTION
};